import React from "react";
import { useDispatch } from "react-redux";

import { IgIconButton, IgPaper, IgTypography } from "@intelligems/ig-theme";
import { Close, ReportProblemOutlined } from "@mui/icons-material";
import { Grid, List, ListItem } from "@mui/material";

import { useGetOrg } from "../../../../api/organizations/get-organization";
import { useLoggedInUser } from "../../../../api/user-auths/login";
import { usePatchUser } from "../../../../api/users/patch-user";
import { setViewedMigrateCampaign } from "../../../../store/slices/appSettings";
import { personalizationsGettingStarted } from "../../../../utils/linkSheet";
import openNewTab from "../../../../utils/openNewTab";

export const MigrateFromCampaignsBanner = () => {
  const user = useLoggedInUser();
  const org = useGetOrg();
  const patchUser = usePatchUser();
  const dispatch = useDispatch();

  const onClearClick = () => {
    if (user.isSuccess && user.data) {
      patchUser.mutate({
        queryParams: undefined,
        pathParams: { id: user.data.user.id },
        body: {
          user: {
            organizationId: org.data.org.id,
            userAlerts: {
              ...user.data.user.userAlerts,
              showPersonalizationMigrateBanner: false,
            },
            id: user.data.user.id,
          },
        },
      });
      dispatch(setViewedMigrateCampaign());
    }
  };
  return (
    <IgPaper
      sx={{
        border: "none",
        padding: "8px 16px",
        boxShadow: "none",
        backgroundColor: "rgba(244, 117, 0, .1)",
        borderRadius: "4px",
      }}
      elevation={0}
    >
      <Grid container direction={"column"}>
        <Grid
          alignItems={"center"}
          container
          direction={"row"}
          justifyContent={"space-between"}
        >
          <Grid item container xs={6}>
            <Grid item mr={1}>
              <ReportProblemOutlined sx={{ color: "#FEB52B" }} />
            </Grid>
            <Grid item>
              <IgTypography
                sx={{
                  fontSize: "16px",
                  fontWeight: 600,
                  color: "rgba(96, 64, 16, 1)",
                }}
              >
                Your Campaigns have been upgraded to Personalizations!
              </IgTypography>
            </Grid>
          </Grid>
          <Grid
            item
            alignItems={"center"}
            justifyContent={"flex-end"}
            container
            xs={6}
          >
            <Grid item>
              <IgTypography
                onClick={() => {
                  openNewTab(
                    personalizationsGettingStarted,
                    "Personalizations - Getting Started"
                  );
                }}
                igStyle={"link"}
                sx={{ color: "rgba(96, 64, 16, 1)", fontSize: "16px" }}
              >
                Learn more
              </IgTypography>
            </Grid>
            <Grid item>
              <IgIconButton size={"small"} onClick={onClearClick}>
                <Close sx={{ color: "rgba(96, 64, 16, 1)", width: "19px" }} />
              </IgIconButton>
            </Grid>
          </Grid>
          <Grid item>
            <List
              component="div"
              disablePadding
              dense={true}
              sx={{ listStyleType: "disc", marginLeft: "18px" }}
            >
              <ListItem
                sx={{ display: "list-item", color: "rgba(96, 64, 16, 1)" }}
              >
                <IgTypography
                  sx={{
                    fontSize: "14px",
                    color: "rgba(96, 64, 16, 1)",
                  }}
                >
                  Personalizations allow you to offer discounts and deals like
                  before, but also to overhaul your branding, layouts, and text
                  - just like Experiments.
                </IgTypography>
              </ListItem>
              <ListItem
                sx={{ display: "list-item", color: "rgba(96, 64, 16, 1)" }}
              >
                <IgTypography
                  sx={{
                    fontSize: "14px",
                    color: "rgba(96, 64, 16, 1)",
                  }}
                >
                  Personalizations can be targeted to everyone, to specific
                  audiences, or to those with a special link.
                </IgTypography>
              </ListItem>
              <ListItem
                sx={{ display: "list-item", color: "rgba(96, 64, 16, 1)" }}
              >
                <IgTypography
                  sx={{
                    fontSize: "14px",
                    color: "rgba(96, 64, 16, 1)",
                  }}
                >
                  You can roll out an experiment’s winning variant into a live
                  Personalization in a few clicks, optimizing your site with
                  minimal effort.
                </IgTypography>
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </Grid>
    </IgPaper>
  );
};
